import axios from 'axios';

export default class GenericAjaxService {
  static getAPI(API, url, config) {
    return new Promise((resolve, reject) => {
      API.get(url, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response.data);
          } else if (error.message){
            reject(error.message);
          } else {
            reject(error);
          }
        });
    });
  }

  static postAPI(API, url, data, config) {
    return new Promise((resolve, reject) => {
      API.post(url, data, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response.data);
          } else if (error.message) {
            reject(error.message);
          } else {
            reject(error);
          }
        });
    });
  }

  static putAPI(API, url, data, config) {
    return new Promise((resolve, reject) => {
      API.put(url, data, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response.data);
          } else if (error.message) {
            reject(error.message);
          } else {
            reject(error);
          }
        });
    });
  }

  static deleteAPI(API, url, config) {
    return new Promise((resolve, reject) => {
      API.delete(url, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response.data);
          } else if (error.message){
            reject(error.message);
          } else {
            reject(error);
          }
        });
    });
  }

  static addRequestInterceptor(API, interceptor) {
    return API.interceptors.request.use(interceptor);
  }

  static removeRequestInterceptor(API, interceptor) {
    API.interceptors.request.eject(interceptor);
  }

  static addResponseInterceptor(API, interceptor) {
    return API.interceptors.response.use(interceptor);
  }

  static addResponseErrorInterceptor(API, interceptor) {
    return API.interceptors.response.use(null, interceptor);
  }

  static removeResponseInterceptor(API, interceptor) {
    API.interceptors.response.eject(interceptor);
  }

  static getCancelToken(){
    return axios.CancelToken;
  }
}